import MyClasses from './MyClasses';

export default MyClasses;